import { connect } from "react-redux";
import InvoiceList from "./invoiceList";
import { bindActionCreators } from "redux";
import { getTaxInvoice } from "services/redux/sales/businessListing/action";
import {documentUploadUrlPublic} from "services/redux/fileUpload/action";
import { verifyInvoicesNumbers, editClientDetails } from "services/redux/maintenance/unclaimedTranx/action";

import {
  fetchZones,
  getListFilterData,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  postSalesList: state.approvedSalesListReducer.postSalesList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  verifyInvoiceNumbersWithRecon: state.UnclaimedTranxReducer.verifyInvoiceNumbersWithRecon,
  editClientDetailsForTan: state.UnclaimedTranxReducer.editClientDetailsForTan,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListFilterData,
      fetchZones,
      getTaxInvoice,
      documentUploadUrlPublic,
      verifyInvoicesNumbers,
      editClientDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList);
